var map = {
	"./admin.svg": "ced6",
	"./cart.svg": "908e",
	"./home.svg": "6bbe",
	"./money.svg": "3046",
	"./newCustomer.svg": "2fcb",
	"./newIssue.svg": "69db",
	"./report.svg": "9e5c",
	"./search.svg": "8e8d",
	"./ticket.svg": "b38e",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";